/**
 * Price offer form (PDP "make an offer" modal).
 *
 * Validation is left to the browser: the rules live on the inputs and the inline
 * messages are revealed by :user-invalid in the CSS. This element only silences
 * the native bubbles, completes the merchant email body, spins the submit button
 * and brings the modal back after the contact form has been posted.
 */
class ProductOfferForm extends HTMLElement {
  connectedCallback() {
    // Closing the modal moves it back out of <body>, which reconnects this element
    if (this.initialized) return;
    this.initialized = true;

    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('invalid', (event) => event.preventDefault(), true);
    this.form.addEventListener('submit', this.onSubmit.bind(this));

    // Shopify reloads the page on submit, so the outcome has to reopen the modal
    if (this.querySelector('.product-offer__message')) {
      requestAnimationFrame(() => this.closest('basic-modal')?.show());
    }
  }

  // Only fires once the browser is happy with every field, so the page is about to reload
  onSubmit() {
    this.form.querySelector('.product-offer__submit')?.classList.add('btn--loading');

    const body = this.form.querySelector('[name="contact[body]"]');
    const amount = this.form.querySelector('[data-offer-amount]');
    if (!body || !amount) return;

    body.value = body.value.replace('%amount%', amount.value);
  }
}
customElements.define('product-offer-form', ProductOfferForm);
